import { createSlice } from "@reduxjs/toolkit";
import {
  fetchLicenseTypes,
  fetchLicenseInformation,
  fetchLicenseMoreDetails,
  fetchDisciplinaryMoreDetails,
  fetchAddLicenses,
  fetchUpdateLicenses,
  fetchDeleteLicenses,
  fetchAddDisciplinaryActions,
  fetchUpdateDisciplinaryActions,
  fetchVerifyDisciplinaryAction,
} from "./ProviderLicenseActions";

import { disciplinaryMoreDetailsMockData } from "../MockData/ProviderLicenseMockData";
import { getApiErrorMessage } from "../../utils/commonUtilities";

const providerLicenseTypesSuggestions = createSlice({
  name: "providerLicenseTypesSuggestions",
  initialState: {
    isTypeLoading: false,
    typeData: [],
    typeError: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchLicenseTypes.pending, (state) => {
        state.isTypeLoading = true;
        state.typeError = null;
      })
      .addCase(fetchLicenseTypes.fulfilled, (state, action) => {
        state.isLanguageLoading = false;
        if (!action.payload.success) {
          if (
            action.payload.data?.metadata?.outcome?.additionalDetails[0]
              ?.additionalInfo
          ) {
            state.languageData = [];
            state.typeError = false;
          } else {
            state.typeError = true;
            state.lngErrorMsg = getApiErrorMessage(action.payload.status);
          }
        } else {
          state.isTypeLoading = false;
          state.typeData = action.payload?.data?.data?.licenseTypeResponseDTO;
        }
      })
      .addCase(fetchLicenseTypes.rejected, (state, action) => {
        state.isTypeLoading = false;
        state.typeError = action.error.message;
      });
  },
});

const providerLicenseInformation = createSlice({
  name: "providerLicenseInformation",
  initialState: {
    isLicenseDataLoading: false,
    LicenseData: [],
    error: null,
    LicenseError: null,
    licenseErrorMsg: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchLicenseInformation.pending, (state) => {
        state.isLicenseDataLoading = true;
        state.error = null;
      })
      .addCase(fetchLicenseInformation.fulfilled, (state, action) => {
        if (!action.payload.success) {
          if (
            action.payload.data?.metadata?.outcome?.additionalDetails[0]
              ?.additionalInfo
          ) {
            state.LicenseData = [];
            state.LicenseError = false;
          } else {
            state.LicenseError = true;
            state.licenseErrorMsg = getApiErrorMessage(action.payload.status);
          }
        } else {
          state.LicenseError = false;
          const updatedResult =
            action.payload.data.data.providerLicenseResponseDTO?.licenses
              ?.slice()
              ?.sort((a, b) => a.stateCode.localeCompare(b.stateCode));
          state.LicenseData = updatedResult;
        }
      })
      .addCase(fetchLicenseInformation.rejected, (state, action) => {
        state.isLicenseDataLoading = false;
        state.error = action.error.message;
      });
    builder
      .addCase(fetchAddLicenses.pending, (state) => {
        state.isLicenseDataLoading = true;
        state.error = null;
      })
      .addCase(fetchAddLicenses.fulfilled, (state, action) => {
        if (!action.payload.success) {
          state.LicenseError = true;
          state.licenseErrorMsg = getApiErrorMessage(action.payload.status);
        }
      })
      .addCase(fetchAddLicenses.rejected, (state, action) => {
        state.isLicenseDataLoading = false;
        state.error = action.error.message;
      });
    builder
      .addCase(fetchUpdateLicenses.pending, (state) => {
        state.isLicenseDataLoading = true;
        state.error = null;
      })
      .addCase(fetchUpdateLicenses.fulfilled, (state, action) => {
        if (!action.payload.success) {
          state.LicenseError = true;
          state.licenseErrorMsg = getApiErrorMessage(action.payload.status);
        }
      })
      .addCase(fetchUpdateLicenses.rejected, (state, action) => {
        state.isLicenseDataLoading = false;
        state.error = action.error.message;
      });
    builder
      .addCase(fetchDeleteLicenses.pending, (state) => {
        state.isLicenseDataLoading = true;
        state.error = null;
      })
      .addCase(fetchDeleteLicenses.fulfilled, (state, action) => {
        if (!action.payload.success) {
          state.LicenseError = true;
          state.licenseErrorMsg = getApiErrorMessage(action.payload.status);
        }
      })
      .addCase(fetchDeleteLicenses.rejected, (state, action) => {
        state.isLicenseDataLoading = false;
        state.error = action.error.message;
      });
    builder
      .addCase(fetchAddDisciplinaryActions.pending, (state) => {
        state.isLicenseDataLoading = true;
        state.error = null;
      })
      .addCase(fetchAddDisciplinaryActions.fulfilled, (state, action) => {
        if (!action.payload.success) {
          state.LicenseError = true;
          state.licenseErrorMsg = getApiErrorMessage(action.payload.status);
        }
      })
      .addCase(fetchAddDisciplinaryActions.rejected, (state, action) => {
        state.isLicenseDataLoading = false;
        state.error = action.error.message;
      });
    builder
      .addCase(fetchUpdateDisciplinaryActions.pending, (state) => {
        state.isLicenseDataLoading = true;
        state.error = null;
      })
      .addCase(fetchUpdateDisciplinaryActions.fulfilled, (state, action) => {
        if (!action.payload.success) {
          state.LicenseError = true;
          state.licenseErrorMsg = getApiErrorMessage(action.payload.status);
        }
      })
      .addCase(fetchUpdateDisciplinaryActions.rejected, (state, action) => {
        state.isLicenseDataLoading = false;
        state.error = action.error.message;
      });
    builder
      .addCase(fetchVerifyDisciplinaryAction.pending, (state) => {
        state.isLicenseDataLoading = true;
        state.error = null;
      })
      .addCase(fetchVerifyDisciplinaryAction.fulfilled, (state, action) => {
        if (!action.payload.success) {
          state.LicenseError = true;
          state.licenseErrorMsg = getApiErrorMessage(action.payload.status);
        }
      })
      .addCase(fetchVerifyDisciplinaryAction.rejected, (state, action) => {
        state.isLicenseDataLoading = false;
        state.error = action.error.message;
      });
  },
});

const providerLicenseMoreDetails = createSlice({
  name: "providerLicenseMoreDetails",
  initialState: {
    isdisciplinaryActionsDataLoading: false,
    licenceDataMoreDetails: {},
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchLicenseMoreDetails.pending, (state) => {
        state.isdisciplinaryActionsDataLoading = true;
        state.error = null;
      })
      .addCase(fetchLicenseMoreDetails.fulfilled, (state, action) => {
        state.isdisciplinaryActionsDataLoading = false;
        state.licenceDataMoreDetails =
          action.payload?.data?.data?.providerLicenseResponseDTO;
      })
      .addCase(fetchLicenseMoreDetails.rejected, (state, action) => {
        state.isdisciplinaryActionsDataLoading = false;
        state.error = action.error.message;
      });
  },
});

const providerDisciplinaryMoreDetails = createSlice({
  name: "providerDisciplinaryMoreDetails",
  initialState: {
    isddisciplinaryMoreDetailsLoading: false,
    disciplinaryMoreDetails: [],
    error: null,
  },
  reducers: {
    addDisciplinaryActionInformation: (state, action) => {
      disciplinaryMoreDetailsMockData.push(action.payload);
      console.log({ disciplinaryMoreDetailsMockData });
    },
    updateDisciplinaryActionMoreInformation: (state, action) => {
      disciplinaryMoreDetailsMockData.length = 0;
      disciplinaryMoreDetailsMockData.push(...action.payload);
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(fetchDisciplinaryMoreDetails.pending, (state) => {
        state.isddisciplinaryMoreDetailsLoading = true;
        state.error = null;
      })
      .addCase(fetchDisciplinaryMoreDetails.fulfilled, (state, action) => {
        state.isddisciplinaryMoreDetailsLoading = false;
        state.disciplinaryMoreDetails = action.payload;
      })
      .addCase(fetchDisciplinaryMoreDetails.rejected, (state, action) => {
        state.isddisciplinaryMoreDetailsLoading = false;
        state.error = action.error.message;
      });
  },
});

export const providerDisciplinaryMoreDetailsReducer =
  providerDisciplinaryMoreDetails.reducer;
export const providerLicenseMoreDetailsReducer =
  providerLicenseMoreDetails.reducer;
export const {
  addLicenseInformation,
  updateLicenseInformation,
  deleteLicense,
} = providerLicenseInformation.actions;
export const { addLicenseMoreInformation, updateLicenseMoreInformation } =
  providerLicenseMoreDetails.actions;
export const {
  addDisciplinaryActionInformation,
  updateDisciplinaryActionMoreInformation,
} = providerDisciplinaryMoreDetails.actions;
export const providerLicenseTypeReducer =
  providerLicenseTypesSuggestions.reducer;
export const providerLicenseInformationReducer =
  providerLicenseInformation.reducer;
